import styled, { css } from 'styled-components';
import { colors, fonts } from '../../theme/styled';
import { media } from '../../theme/media';

export const GoogleSearchWrapper = styled.form`
  width: 100%;

  ${props =>
    props.isPadded &&
    css`
      padding: 32px 0 18px;

      ${media.tablet`
        padding: 32px 0;
        border-top: 1px solid ${colors.borderMenuItem};
      `};
    `}

  ${media.tabletLarge`
    border-top: 0;
    order: 2;
    padding: 0;
  `}
`;

export const GoogleSearchInnerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  ${props =>
    props.isPadded &&
    css`
      ${media.tablet`
        margin-left: 40px;
        width: calc(60% - 80px);
      `};
    `}

  ${media.tabletLarge`
    width: 100%;
    margin: 0;
  `};
`;

export const SearchInput = styled.input`
  background: ${colors.white};
  height: 48px !important;
  padding: 0 20px !important;
  font-size: 18px;
  font-family: 'Open Sans', sans-serif !important;
  color: ${colors.darkGrey};
  font-weight: 300;
  border: none;
  flex: 1;
  width: calc(100% - 48px);
`;

export const SubmitButton = styled.button`
  appearance: none;
  border-radius: 0;
  border: 0;
  background: ${colors.yellow};
  margin: 0;
  height: 48px;
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 !important;
  cursor: pointer;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const Label = styled.label`
  font-size: 13px;
  font-family: ${fonts.smallFont};
  color: ${colors.mediumGrey};
  margin: 0 0 6px;
  width: 100%;
`;
